import {format} from "date-fns";

export function displayClassDuration(time){
    const runtime = time + 1;
    return `${parseInt(runtime / 60)} min`;
}

export function displayAiredDate(classNumber, airDateTime){
    const airedDate0 = classNumber ? "·" : "";
    const airedDate1 = format(new Date(airDateTime), "MMM D, YYYY");
    const airedDate2 = format(new Date(airDateTime), "hh:mm A");
    if(airDateTime){
        return `Aired ${airedDate0} ${airedDate1} at ${airedDate2}`
    }
    return ""						
}